module.exports = __webpack_public_path__ + "media/images/athletes/1751-6c1fbca8554e679be6a3e740bc532ef5.png";